// @ts-expect-error not typed
import MultiCompareEmailsLink from 'email-management-lib/refactor/components/manage/dashboardTable/MultiCompareEmailsLink';
import { List } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
function BulkCompareButton({
  hasComparisonToolAccess,
  selectedEmailIds
}) {
  if (selectedEmailIds.size <= 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(MultiCompareEmailsLink, {
    hasComparisonToolAccess: hasComparisonToolAccess,
    selectedEmailIds: List(selectedEmailIds)
  });
}
export default BulkCompareButton;